import {
  ClickAwayListener,
  Grow,
  MenuListProps,
  Paper,
  Popper,
} from "@mui/material";
import React from "react";
import { MuiBox } from "../box/MuiBox";
import { MuiPopupWrapper } from "./MuiPopup.style";

interface MuiMenuProps extends MenuListProps {
  open: boolean;
  onClose: () => void;
  refValue: HTMLButtonElement | null;
  forceClose: boolean;
}

export const MuiPopup = (props: MuiMenuProps) => {
  const {
    open,
    refValue: anchorRefValue,
    onClose,
    children,
    forceClose,
  } = props;

  const prevOpen = React.useRef(open);
  const prevForceClose = React.useRef(forceClose);
  React.useEffect(() => {
    if (anchorRefValue && prevOpen.current === true && open === false) {
      anchorRefValue!.focus();
    }
    prevOpen.current = open;
  }, [anchorRefValue, open]);

  React.useEffect(() => {
    if (prevForceClose.current != forceClose) {
      onClose();
    }
    prevForceClose.current = forceClose;
  }, [forceClose]);

  return (
    <MuiPopupWrapper>
      <Popper
        open={open}
        anchorEl={anchorRefValue}
        role={undefined}
        placement="bottom-end"
        transition
        disablePortal
        className="popper"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper id="menu-paper">
              <ClickAwayListener onClickAway={onClose}>
                <MuiBox>{children}</MuiBox>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </MuiPopupWrapper>
  );
};
